<template>
  <div class="Alpha-Post-Menu" ref="menuRef">
    <ButtonPoints class="Alpha-Post-Menu__btn" @click="toToggleMenu"/>
    <transition name="Anim__fadeUp">
      <DropMenuPost class="Alpha-Post-Menu__dropdown" :postId="props.postId" v-if="isOpen"/>
    </transition>
  </div>
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------------------------
  import DropMenuPost from '@features/DropMenu/modules/DropMenuPost/DropMenuPost.vue';
  import ButtonPoints from '@ui/Buttons/ButtonPoints/ButtonPoints.vue';
  //--------------------------------------------
  const props = defineProps(Props());
  const isOpen = ref(false);
  const menuRef = ref(null);
  //--------------------------------------------
  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
  });
  //--------------------------------------------
  //Отобразить/скрыть меню
  const toToggleMenu = () => isOpen.value = !isOpen.value;
  //Закрыть меню, если клик вне области меню
  const handleClickOutside = (event) => {
    if(menuRef.value && !menuRef.value.contains(event.target)) {
      isOpen.value = false;
    }
  };
</script>

<style lang="scss">
  @import './styles/_styles';
</style>